// extracted by mini-css-extract-plugin
export default {"detalleGol":"DetalleGolesEquipo_detalleGol__hKX7l","tiempoGol":"DetalleGolesEquipo_tiempoGol__fFlyb","autorGol":"DetalleGolesEquipo_autorGol__ZQuin"};